module.exports = __webpack_public_path__ + "img/statement.58e80d78.svg";